import ContractSummaryInput from './ContractSummaryInput'

export default ContractSummaryInput
